<template>
  <div class="modal-backdrop">
    <div class="modal-dialog" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">{{ $t('create-segment') }}</h5>
          <button type="button" class="close" @click="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="form-group">
            <label>
              {{ $t('name-segment') }}
            </label>
            <input type="text" :placeholder="$t('name-segment')" v-model="segment.name">
            <span class="error" v-if="errors.name">{{ errors.name[0] }}</span>
            <label class="mt-1">{{ $t('count-clients') }}: {{ this.segment.clients_id.length }}</label>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" @click="close">{{ $t('close') }}</button>
          <button type="button" class="btn btn-primary" @click="createSegment">{{ $t('to-create') }}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: 'create-segment-modal',
  props: ['client'],
  data: function(){
    return{
      segment: {
        name: null,
        clients_id: this.client
      },
      errors: [],
    }
  },
  watch: {
    client: function (val) {
      this.segment.clients_id = val;
    },
  },
  methods: {
    close: function() {
      this.$emit('close');
    },
    createSegment: function(){
      axios.post('createSegment', this.segment).then(response => {
        var status = response.data.status;
        if(status){
          this.segment.name = null;
          this.errors = [];
          this.$emit('close');
          this.$root.$emit('updateSegments');
          this.$toast.success("Сегмент успешно создан");
        }else{
          this.errors = response.data.errors;
          if(response.data.error){
            this.$toast.error(response.data.error);
          }
        }
      });
    }
  },
};
</script>

<style scoped>
.modal-backdrop {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-header,
.modal-footer {
  padding: 15px;
  display: flex;
}

.modal-header {
  position: relative;
  border-bottom: 1px solid #eeeeee;
  color: #000000;
  justify-content: space-between;
}

.modal-footer {
  border-top: 1px solid #eeeeee;
}
</style>